/**
 * The star beside a direct product's part number (CR-7717). Direct products
 * are ticked by the customer in the parts list; the star shows on Stock
 * Planning and the call-off warehouse grid so they stand out while planning.
 */
import { Star } from 'lucide-react';

export default function DirectProductStar() {
  return (
    <span title="Direct product" aria-label="Direct product" className="inline-flex align-text-bottom mr-1">
      <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-500" aria-hidden="true" />
    </span>
  );
}
